import { useCallback } from 'react';
import { useAppStore } from 'store/store-hooks';

import { RootState } from 'store/store';
import { getPath, Path } from 'components/_hooks/use-router';
import { useSelectorContext } from 'components/app/selector/_mediator/selector.provider';
import { useSbPlayerContext } from 'components/app/storyboard/sb-player/_mediator/sb-player.provider';

export const useEditorCb = () => {
  const store = useAppStore();
  const { srPlayerRef } = useSelectorContext();
  const { sbPlayers } = useSbPlayerContext();

  const getPlayerRef = useCallback(() => {
    const { activePlayerIndex } = selectData(store.getState());
    const path = getPath();
    if (path === Path.selector) return srPlayerRef.current;
    if (path === Path.storyboard) return sbPlayers.current[activePlayerIndex];
    return null;
  }, []);

  return { getPlayerRef };
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { activePlayerIndex } = state.sb__player;
  return { activePlayerIndex };
};
